import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { IconButton } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import { useFormik, yupToFormErrors } from "formik";
import InputField from "../../../common/CustomInputField";
import RadioButton from "../../../common/RadioButton";
import MultiSelect from "../../../common/MultiSelect";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { getSubChilds } from "../../../services/yourAssets/CommonServices";
import { useParams } from "react-router-dom";
import { getKeyFromText } from "../../../utils/Utilities";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  bgcolor: "background.paper",
  minWidth: "350px !important",

  background: "color.white",
  boxShadow:
    "  0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
  padding: "0px 0 10px 0",
  display: "flex",
  flexDirection: "column",
};

const BasicModal = (props) => {
  const {
    open,
    handleClose,
    focusedProperty,
    propertyTypeId,
    addSubOwnersData,
    deleteSubOwnersData,
    selectedSubOwner = {},
    selectedSubOwnerIndex,
  } = props;
  const { t } = useTranslation();
  const { id } = useParams();
  const { name, key, sharesData } = focusedProperty;
  const types = [
    {
      value: "My Self",
      label: t("rs-input-resident-3"),
      pureLabel: "My Self",
      id: 1,
    },
    {
      value: "Kids",
      label: t("rs-input-resident-1"),
      pureLabel: "Kids",
      id: 2,
    },
    {
      value: "Renting",
      label: t("rs-input-resident-2"),
      pureLabel: "Renting",
      id: 3,
    },
    {
      value: "GrandKids",
      label: t("rs-input-resident-5"),
      pureLabel: "Grand Kids",
      id: 4,
    },
  ];

  const [subChilds, setSubChilds] = useState([]);
  const [subChildsBackup, setSubChildsBackup] = useState("");

  const [propertyType, setPropertyType] = useState([]);
  let array = [];

  if (
    Object.keys(selectedSubOwner).length > 0 &&
    Array.isArray(selectedSubOwner?.propertyType)
  )
    selectedSubOwner?.propertyType?.forEach(
      (elem) =>
        (array = [...array, { ...elem, label: t(getKeyFromText(elem.label)) }])
    );

  const initialValues =
    Object.keys(selectedSubOwner).length > 0
      ? { ...selectedSubOwner, propertyType: array }
      : {
          nameOfOwners: "",
          ownership: "",
          valueOfTheProperty: "",
          date: "",
          propertyType: "",
          childs: "",

          areaLT200ms: false,
        };
  let arr = [];
  if (Object.keys(selectedSubOwner).length > 0) {
    propertyType.length &&
      selectedSubOwner?.propertyType?.forEach(
        (item) =>
          (arr = [
            ...arr,
            {
              ...item,
              label: t(getKeyFromText(item.label)),
            },
          ])
      );
  }
  useEffect(() => {
    setPropertyType(arr);
  }, []);
  const validate = Yup.object({
    nameOfOwners: Yup.string()
      .required(t("required"))
      .max(50, t("max-50-characters"))
      .nullable(),
    ownership: Yup.number()
      .min(0, t("between-0-100"))
      .max(100, t("between-0-100"))
      .required(t("required")),
    valueOfTheProperty: Yup.number()
      .required(t("required"))
      .min(0, t("must-be-positive"))
      .max(9999999999, t("max-10-digits")),
      date: Yup.string()
      .required(t("required"))
      .nullable()
      .test("DATE", t("choose-between-1930"), (value) => {
        if (value) {
          let [yyyy, mm, dd] = value?.split("-");
          let currentDate = new Date(Date.now()).toLocaleDateString("en-GB");
          let [curDay, curMonth, curYear] = currentDate.split("/");
          return 1930 <= yyyy && curYear >= yyyy;
        }
      }),
    
    // date: Yup.string()
    //   .test("DATE", t("between-1950-2050"), (value) => {
    //     if (value) {
    //       let [yyyy, mm, dd] = value?.split("-");
    //       return 1950 <= yyyy && yyyy <= 2050;
    //     }
    //   })
    //   .nullable(),
    propertyType: Yup.array().test(
      "Resident",
      t("no-renting-with-other"),
      function (values) {
        if (values?.length > 1) {
          return !values?.some((el) => el.id == 3);
        }
        return true;
      }
    ),

    childs: Yup.array(),

    areaLT200ms: Yup.boolean(),
  });

  useEffect(() => {
    const getList = async () => {
      let key = localStorage.getItem("loggedInUserId");
      let result = await getSubChilds(id ? id : key);
      if (result) {
        let case1 = false;
        let case2 = false;

        selectedSubOwner?.propertyType?.map((item) => {
          if (item.id === 2) {
            case1 = true;
          } else if (item.id === 4) {
            case2 = true;
          }
        });

        setSubChildsBackup(result);
        getChildsAndGrandChilds(case1, case2, result);
      }
    };
    getList();
  }, []);

  const onSubmit = async (values, onSubmitProps) => {
    const formattedDate =
      values.date instanceof dayjs
        ? values.date.format("YYYY-MM-DD")
        : values.date;
    const updatedValues = {
      ...values,
      date: formattedDate,
    };
    addSubOwnersData(updatedValues, propertyTypeId, key, selectedSubOwnerIndex);
    onSubmitProps.resetForm();
    handleClose();
  };

  const getPropertyLimit = (list) => {
    for (let i = 0; i < list.length; i++) {
      const element = list[i];
      if (element.label === "Kids") {
        return (
          <RadioButton
            label={t("rs-input-resident-note")}
            name="areaLT200ms"
            id={1}
            value={1}
            checked={formik.values.areaLT200ms}
            onChange={formik.handleChange}
          />
        );
      }
    }
  };

  const handlePropertyType = async (value) => {
    setPropertyType(value);
    let arr = [];
    value.forEach((item) => {
      arr = [
        ...arr,
        { ...item, label: types.find((el) => el.id == item.id).pureLabel },
      ];
    });
    value = [...arr];
    let rArray = [
      {
        value: "Renting",
        label: "Renting",
        id: 3,
      },
    ];
    for (let i = 0; i < value.length; i++) {
      let elementI = value[i];
      if (elementI.value === "Renting") {
        value = rArray;
        break;
      }
    }
    setPropertyType(value);
    let newVal = value.map((elem) => {
      return { ...elem, label: t(getKeyFromText(elem.label)) };
    });
    formik.setFieldValue("propertyType", newVal);

    let case1 = false;
    let case2 = false;
    for (let i = 0; i < value.length; i++) {
      const elementI = value[i];
      if (elementI.value === "Kids") case1 = true;
      else if (elementI.value === "GrandKids") case2 = true;
    }

    let check = "";
    if (!case1 && !case2) {
      check = ["child", "grand child"];
    } else {
      if (!case1) {
        check = ["child"];
      } else if (!case2) {
        check = ["grand child"];
      }
    }

    if (check) {
      let fieldValue = formik.values.childs;
      if (fieldValue) {
        let list = fieldValue?.filter((item) => {
          return !check.includes(item.type);
        });
        formik.setFieldValue("childs", list);
      }
    }

    if (subChildsBackup.length === 0) {
      let key = localStorage.getItem("loggedInUserId");

      let result = await getSubChilds(id ? id : key);
      if (result) {
        setSubChildsBackup(result);
        getChildsAndGrandChilds(case1, case2, result);
      }
    } else {
      getChildsAndGrandChilds(case1, case2, subChildsBackup);
    }
  };
  const getChildsAndGrandChilds = async (case1, case2, result) => {
    let actualList = [];
    if (subChilds.length) {
      let arr = subChilds.map((elem) => ({
        ...elem,
        label: t(getKeyFromText(elem.label)),
      }));
      actualList = [...arr];
    }
    actualList?.forEach((elem) => {
      if (elem.label === "Kids") elem.label = "child";
      else if (elem.label === "Grand Kids") elem.label = "grand child";
    });

    if (case1) {
      let check = actualList.some((item) => {
        return item.label === "child";
      });
      let list = result?.childs?.map((item) => {
        return {
          value: item.name,
          label: item.name,
          id: item.familyTreeId,
          type: "child",
        };
      });
      if (!check) {
        let obj = {
          label: "child",
          options: list.length ? list : [],
        };
        actualList.unshift(obj);
      }
    } else {
      let list = actualList?.filter((item) => {
        return item.label !== "child";
      });
      actualList = [...list];
    }
    if (case2) {
      let check = actualList.some((item) => {
        return item.label === "grand child";
      });

      let list = result?.grandChilds?.map((item) => {
        return {
          value: item.name,
          label: item.name,
          id: item.familyTreeId,
          type: "grand child",
        };
      });
      if (!check) {
        let obj = {
          label: "grand child",
          options: list.length ? list : [],
        };
        actualList.push(obj);
      }
    } else {
      let list = actualList?.filter((item) => {
        return item.label !== "grand child";
      });

      actualList = [...list];
    }

    actualList = actualList.map((elem) => ({
      ...elem,
      label: t(getKeyFromText(elem.label)),
    }));
    setSubChilds([...actualList]);
  };

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: onSubmit,
    validationSchema: validate,
    enableReinitialze: true,
  });

  let optionsArr = [];
  const checkTranslation = () => {
    types.forEach((item) => {
      optionsArr = [
        ...optionsArr,
        {
          ...item,
          label: item?.translationKey ? t(item.translationKey) : item.label,
        },
      ];
    });
  };
  checkTranslation();

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <Box sx={style}>
            <Box
              lg={12}
              sx={{
                backgroundColor: "color.magentaLight2",
                padding: "10px",
                color: "color.brown",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                style={{ textTransform: "capitalize" }}
                id="modal-modal-title"
                pl={3}
                component="p"
              >
                {t(getKeyFromText(name.substring(0, name.length - 2)))}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                {/* <IconButton
                  sx={{
                    cursor: "pointer",
                    paddingRight: "20px",
                  }}
                  aria-label="delete"
                  size="small"
                  onClick={() =>
                    deleteSubOwnersData(
                      propertyTypeId,
                      selectedSubOwnerIndex,
                      key
                    )
                  }
                >
                  <DeleteOutlinedIcon />
                </IconButton> */}
                <Typography
                  onClick={() => handleClose()}
                  sx={{
                    cursor: "pointer",
                  }}
                  pr={1}
                  variant="h6"
                  component="h2"
                >
                  <img src="/assets/icons/close-icon.svg" alt="Close" />
                </Typography>
              </Box>
            </Box>
            <FormControl sx={{ width: "100%", padding: "20px " }}>
              <InputField
                label={t("common-table-heading-1")}
                value={formik.values.nameOfOwners}
                onChange={formik.handleChange}
                error={
                  Boolean(
                    formik?.errors?.nameOfOwners &&
                      formik?.touched?.nameOfOwners
                  )
                    ? formik.errors
                    : null
                }
                name="nameOfOwners"
                placeholder={t("placeholder-1")}
                maxlength={50}
              />
              <InputField
                type="number"
                label={t("common-table-heading-2")}
                value={formik.values.ownership}
                onChange={formik.handleChange}
                error={
                  Boolean(
                    formik?.errors?.ownership && formik?.touched?.ownership
                  )
                    ? formik.errors
                    : null
                }
                name="ownership"
                placeholder="00%"
                
              />

              {/* <InputField
                type="number"
                label={t("rs-table-heading-2")}
                value={formik.values.valueOfTheProperty}
                onChange={formik.handleChange}
                name="valueOfTheProperty"
                placeholder="00 € "
                error={
                  Boolean(
                    formik?.errors?.valueOfTheProperty &&
                      formik?.touched?.valueOfTheProperty
                  )
                    ? formik.errors
                    : null
                }
              /> */}
              <InputField
                type="format-number"
                label={t("rs-table-heading-2")}
                value={
                  formik.values.valueOfTheProperty
                    ? `${formik.values.valueOfTheProperty} €`
                    : "0 €"
                }
                onChange={(value) => {
                  formik.setFieldValue("valueOfTheProperty", value);
                }}
                name="valueOfTheProperty"
                placeholder="00 € "
                error={
                  Boolean(
                    formik?.errors?.valueOfTheProperty &&
                      formik?.touched?.valueOfTheProperty
                  )
                    ? formik.errors
                    : null
                }
              />
              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker", "DatePicker"]}>
                  <DatePicker
                    className="new-date"
                    label={t("common-table-heading-3")}
                    value={values}
                    onChange={(newValue) => setValues(newValue)}
                    format="DD MMMM YYYY"
                  />
                </DemoContainer>
              </LocalizationProvider> */}
              {/* <InputField
                // type="date"
                label={t("common-table-heading-3")}
                value={formik.values.date?.slice(0, 10) || ""}
                onChange={formik.handleChange}
                name="date"
                placeholder="TT.MM.JJJJ"
                type="datepicker"
                onFocus={(e) => (e.target.type = "date")}
                // error={
                //   Boolean(formik?.errors?.date && formik?.touched?.date)
                //     ? formik.errors
                //     : null
                // }
              /> */}

              <InputField
                type="date"
                label={t("common-table-heading-3")}
                value={formik.values.date ? dayjs(formik.values.date).toDate() : null}
                onChange={(value) => {
                  formik.setFieldValue("date", value ? dayjs(value).format("YYYY-MM-DD") : null);
                }}
                name="date"
                error={
                  Boolean(
                    formik?.errors?.date &&
                      formik?.touched?.date
                  )
                    ? formik.errors
                    : null
                }
              />
              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label={t("common-table-heading-3")}
                  value={values.date}
                  onChange={(newValue) => {
                    formik.setFieldValue("date", newValue); // Update the date value
                  }}
                  format="DD MMMM YYYY"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      type="text"
                      placeholder="DD.MM.YYYY"
                      onFocus={(e) => (e.target.type = "date")}
                    />
                  )}
                />
              </LocalizationProvider> */}

              {sharesData.length === 0 || selectedSubOwnerIndex === 0 ? (
                <>
                  <MultiSelect
                    className="multiselectss"
                    label={t("rs-input-resident")}
                    value={formik.values.propertyType}
                    onChange={(value) => {
                      handlePropertyType(value);
                    }}
                    menuList={optionsArr}
                    isMulti={true}
                    name="propertyType"
                    placeholder={t("please-select")}
                    error={
                      Boolean(
                        formik?.errors?.propertyType &&
                          formik?.touched?.propertyType
                      )
                        ? formik.errors
                        : null
                    }
                  />

                  {getPropertyLimit(formik.values.propertyType)}
                </>
              ) : null}
              {(sharesData.length === 0 || selectedSubOwnerIndex === 0) && (
                <MultiSelect
                  label={t("rs-input-resident-4")}
                  value={formik.values.childs}
                  onChange={(value) => {
                    formik.setFieldValue("childs", value);
                  }}
                  menuList={subChilds}
                  isMulti={true}
                  name="childs"
                  placeholder={t("please-select")}
                  error={
                    Boolean(formik?.errors?.childs && formik?.touched?.childs)
                      ? formik.errors
                      : null
                  }
                />
              )}
            </FormControl>

            <Button
              sx={{
                color: "color.brown",
                padding: "8px 50px",
                backgroundColor: "color.magentaLight2",
                margin: "4rem auto 1rem auto",
                fontWeight: "bold",
                borderRadius: "15px",
                textTransform: "initial",
                "&:hover": {
                  backgroundColor: "color.magentaLight1",
                  boxShadow: "none",
                },
              }}
              onClick={formik.handleSubmit}
            >
              {t("save")}
            </Button>
          </Box>
        </div>
      </Modal>
    </div>
  );
};

export default BasicModal;
